import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const useAuthChecker = () => {
  const { registerData } = useSelector((state) => state.auth);
  const [isToken, setIsToken] = useState(false);
  let isAuthCompleted = registerData?.access_token ? true : false;

  useEffect(() => {
    setIsToken(localStorage.getItem("USER_ACCESS_TOKEN"));
  });

  return { isAuthCompleted, isToken };
};

export default useAuthChecker;
